import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  const surfaceConfig = theme.palette.surface[theme.palette.type];
  const containedConfig = surfaceConfig.button.contained;
  const outlinedConfig = surfaceConfig.button.outlined;
  const buttonConfig = theme.typography.button;

  return {
    root: {
      display: 'flex',
      flex: '0 0 auto',
      alignItems: 'center',
      justifyContent: 'left',
    },
    btnContained: {
      marginLeft: 0,
      paddingLeft: buttonConfig.paddingLeft,
      paddingRight: buttonConfig.paddingRight,
      borderRadius: buttonConfig.borderRadius,
      height: buttonConfig.height,
      backgroundColor: containedConfig.bgColor,
      '&:hover': {
        backgroundColor: containedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: containedConfig.border,
        borderColor: containedConfig.borderColor,
        backgroundColor: containedConfig.bgColor,
      },
    },
    btnOutlined: {
      border: outlinedConfig.border,
      color: outlinedConfig.color,
      marginRight: theme.spacing(1),
      backgroundColor: outlinedConfig.bgColor,
      '&:hover': {
        border: outlinedConfig.hoveredBorder,
        backgroundColor: outlinedConfig.hoveredBgColor,
      },
      '&:focus': {
        border: outlinedConfig.selectedBorder,
        backgroundColor: outlinedConfig.selectedBgColor,
      },
    },
  };
});

const ConfirmDialog = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  closeButtonLabel,
  confirmButtonLabel,
}) => {
  const classes = useStyles();

  const handleConfirm = () => {
    onConfirm && onConfirm();
  };

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          {title}
          <span />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            className={classes.btnOutlined}
          >
            {closeButtonLabel}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            className={classes.btnContained}
          >
            {confirmButtonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ])),
  ]),
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  closeButtonLabel: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
};

ConfirmDialog.defaultProps = {
  title: 'Confirm',
  content: null,
  onClose: undefined,
  onConfirm: undefined,
  closeButtonLabel: 'Cancel',
  confirmButtonLabel: 'Confirm',
};

export default ConfirmDialog;
